import React from 'react';
import iconFlip from '../../../components/images/icons/IconFlipEffectW64.png';
import './scheda.scss';

function Scheda({cards}) {
    
    return (
        <div className="container-schede">
            {cards && 
            <div className="schede">
                {cards.map(card => (
                <div className="scheda" key={card._id}>
                    <div className='face front'>
                        <div className="recto">
                            <div className="recto__infosheet">
                                <h1 className="infosheet__titolo">{card.titoloUp}</h1>
                            </div>
                            <div className="infosheet__paragraph--up">
                                <p dangerouslySetInnerHTML={{ __html: card.parafUp }}/>
                            </div>
                            <div className="infosheet__paragraph--down">
                                <p dangerouslySetInnerHTML={{ __html: card.parafDown }}/>  
                            </div>
                            <div className="infosheet__footer">
                                <p>Riassunto: {card.titoloUp}</p>
                            </div>
                        </div>
                    </div>
                    <div className='face back' key={card._id}>
                        <div className="verso" style={{backgroundColor: `${card.bgColor}`, border: `${card.border}`}} >
                            <div className="verso__infosheet">
                                <p className="scheda__titolo" style={{color: `${card.wColor}`}}>{card.titoloUp}</p>
                            </div>
                            <img className='verso__img' src={require(`../../../components/images/${card.card_pic}`)}  alt="theme face" />
                            {/* <div className="verso__infosheet">
                                <p className="scheda__titolo" style={{color: `${card.wColor}`}}>{card.titoloDown}</p>
                            </div> */}
                            <div className="schede__dica">
                                <p className='dica'>Passa il mouse sopra la scheda</p>
                                <p className='dica'>per visualizzare l'altro lato</p>
                                <img src={iconFlip} alt="icon for flip effect" />
                            </div>
                        </div> 
                    </div>
                </div>
                ))}
            </div>}
        </div>
    )
}
export default Scheda;
